/*******************************************************
 ***************************************** Lokking for
 *******************************************************/

(function($, window, document, undefined) {
  'use strict';

  $(function() {
    $('input[data-toggle="radio-toggle"]').change(function(){
      var target = $(this).data('target');

      $(target).siblings().collapse('hide');
      $(target).collapse('show');
    });
  });

}(jQuery, this, document));